// modules & hooks
import React, { useEffect, useState } from "react";
import { MEDIA_QUERIES } from "../../../constants";
import useWindowSize from "../../../hooks/useWindowSize";
// assets
import SuccessIcon from "../../../assets/img/popup/success-icon.png";
// antd
import { getUser } from "../../../services/users";
import { Col, Form, Input, Row } from "antd";

const WalletInfo = ({ data }) => {
  // states
  const [isApproved, setIsApproved] = useState(true);

  // window size
  const windowSize = useWindowSize();

  const [userData, setUserData] = useState(null);
  useEffect(() => {
    getUser().then((user) => {
      setUserData(user);
    });
  }, []);

  return (
    <div className="wallet-info infoBx">
      <div className="infoBx-heading">
        <h3 className="container-heading">
          {!userData ? "" : userData?.type === "company" ? "KYB Status" : "KYC Status"}
        </h3>
        <p className="status">
          <img src={SuccessIcon} alt="Success icon" />
          <span>{isApproved ? "Approved" : null}</span>
        </p>
      </div>
      <div className="info__content">
        <Row gutter={16}>
          <Col className="gutter-row" span={windowSize.width < MEDIA_QUERIES.MD ? 24 : 12}>
            <Form.Item
              name="Wallet"
              label="Wallet"
              rules={[
                {
                  required: true,
                },
              ]}>
              <Input value="-" placeholder="-" disabled={isApproved} />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={windowSize.width < MEDIA_QUERIES.MD ? 24 : 12}>
            <Form.Item
              name="EURST Balance"
              label="EURST Balance"
              rules={[
                {
                  required: true,
                },
              ]}>
              <Input type="text" value="-" placeholder="-" disabled={isApproved} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col className="gutter-row" span={windowSize.width < MEDIA_QUERIES.MD ? 24 : 12}>
            <Form.Item
              name="Wallet Address"
              label="Wallet Address"
              rules={[
                {
                  required: true,
                },
              ]}>
              <Input type="text" placeholder="tyuyiouoiopijuoiipo" disabled={isApproved} />
            </Form.Item>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default WalletInfo;
